/** Privacy policy footer link — CrazyGames builds only. */

/**
 * @param {string | null | undefined} [buildVariant]
 * @returns {boolean}
 */
export function shouldShowPrivacyPolicyLink(buildVariant) {
  return buildVariant === "crazygames";
}

/**
 * @param {HTMLElement | null | undefined} el
 * @param {string | null | undefined} [buildVariant]
 */
export function applyPrivacyPolicyLinkVisibility(el, buildVariant) {
  if (!el) return;
  if (shouldShowPrivacyPolicyLink(buildVariant)) {
    el.classList.remove("hidden");
    el.removeAttribute("aria-hidden");
    return;
  }
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
}
